import { render, staticRenderFns } from "./Product_title.vue?vue&type=template&id=45016dfe&scoped=true&"
import script from "./Product_title.vue?vue&type=script&lang=js&"
export * from "./Product_title.vue?vue&type=script&lang=js&"
import style0 from "./Product_title.vue?vue&type=style&index=0&id=45016dfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45016dfe",
  null
  
)

export default component.exports